import React, { JSX, useState } from "react";
import { Outlet } from "react-router";
import {
    GroupSearchContext,
    GroupSearchCriteria,
    defaultGroupSearchCriteria,
} from "utilities/contexts/search/group/group-search-context";

interface AdminGroupLayoutProps {}

// Keeps GroupSearchCriteria in scope across the groups list page and its detail routes, without leaking to other admin sections.
const AdminGroupLayout: React.FC<AdminGroupLayoutProps> = (): JSX.Element => {
    const [groupSearchCriteria, setGroupSearchCriteria] = useState<GroupSearchCriteria>(
        defaultGroupSearchCriteria
    );

    return (
        <GroupSearchContext.Provider
            value={{ initialCriteria: groupSearchCriteria, setCriteria: setGroupSearchCriteria }}>
            <Outlet />
        </GroupSearchContext.Provider>
    );
};

export { AdminGroupLayout };
